<template>
    <v-container grid-list-md pa-0 ma-2 style="max-width: calc(100% - 16px)">
        <v-layout wrap>
            <v-flex xs12 pb-0 pt-0 style="min-height: 60px">
                <v-layout wrap>
                    <v-flex sl8 md6>
                        <SelectCreditors
                            :multiple="false"
                            :clearable="false"
                            :negotiation="true"
                            :selected="selectedCreditor"
                            @selectedCreditors="selectedCreditor = $event"
                        ></SelectCreditors>
                    </v-flex>
                    <v-flex xs12 md6>
                        <v-select
                            box
                            multiple
                            clearable
                            class="text-details-none"
                            label="Tipo de abordagem"
                            :items="approachesTypes"
                            v-model="selectedApproachTypes"
                        >
                            <template v-slot:selection="{ item, index }">
                                <span v-if="index <= 2">{{
                                    index === 0 ? item : ", " + item
                                }}</span>
                                <span
                                    v-if="index === 3"
                                    style="padding-left: 5px"
                                    class="grey--text caption"
                                    >(+{{
                                        selectedApproachTypes.length -
                                        3 +
                                        (selectedApproachTypes.length == 4
                                            ? " outro)"
                                            : " outros)")
                                    }}</span
                                >
                            </template>
                        </v-select>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12>
                <v-tabs
                    grow
                    color="gray"
                    style="
                        border: 1px solid rgba(0, 0, 0, 0.12);
                        border-radius: 4px;
                    "
                    v-model="tableTab"
                >
                    <v-tab v-for="(tab, key) in publicTabs" :key="key">
                        <p
                            :class="`subheading font-weight-regular ${tab.color}--text`"
                        >
                            {{ tab.name }}
                        </p>
                    </v-tab>
                    <v-tabs-slider
                        :color="publicTabs[tableTab].color"
                    ></v-tabs-slider>
                    <v-tab-item v-for="(itemTab, k) in publicTabs" :key="k">
                        <v-data-table
                            :headers="headers"
                            :items="allStrategies[itemTab.value].data"
                            :total-items="
                                allStrategies[itemTab.value].totalItems
                            "
                            :pagination.sync="
                                allStrategies[itemTab.value].pagination
                            "
                            :rows-per-page-items="
                                allStrategies[itemTab.value].rowsPerPageItems
                            "
                        >
                            <template v-slot:items="props">
                                <tr style='opacity:.5;'>

                              
                                <td style="line-height: 24px">
                                    <p v-if="props.item.creditor">
                                        {{ props.item.creditor.name }}
                                    </p>
                                </td>
                                <td style="display: flex">
                                    <v-tooltip
                                        top
                                        v-if="props.item.only_enrichment"
                                        class="mr-1"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-icon small color="blue" v-on="on"
                                                >mdi-circle</v-icon
                                            >
                                        </template>
                                        <span
                                            >Somente contatos enriquecidos</span
                                        >
                                    </v-tooltip>
                                    <v-tooltip
                                        top
                                        v-if="props.item.not_only_enrichment"
                                        class="mr-1"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-icon small color="red" v-on="on"
                                                >mdi-circle</v-icon
                                            >
                                        </template>
                                        <span
                                            >Somente contatos não
                                            enriquecidos</span
                                        >
                                    </v-tooltip>
                                    <v-tooltip v-if="props.item.name" top>
                                        <template v-slot:activator="{ on }">
                                            <div
                                                v-on="on"
                                                style="
                                                    display: inline-grid;
                                                    align-items: center;
                                                "
                                            >
                                                <p class="mb-0 truncate">
                                                    #{{ props.item.id }} -
                                                    {{ props.item.name }}
                                                </p>
                                            </div>
                                        </template>
                                        <span>{{ props.item.name }}</span>
                                    </v-tooltip>

                                    <v-menu
                                        v-if="hasTag(props.item)"
                                        :close-on-content-click="false"
                                        :nudge-width="300"
                                        offset-x
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                flat
                                                icon
                                                color="accent"
                                                v-on="on"
                                                style="margin: auto 0 auto 2px"
                                            >
                                                <v-icon>local_offer</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-card>
                                            <v-list pa-0>
                                                <v-list-tile v-if="props.item.tags_v2">
                                                    Negócio: 
                                                    <v-chip
                                                        v-for="(item,
                                                        index) in props.item.tags_v2.split(',')"
                                                        :key="index"
                                                        outline
                                                        small
                                                        color="dark-yellow"
                                                        >{{ item }}
                                                    </v-chip>
                                                </v-list-tile>
                                                <v-divider v-if="props.item.tags_v2 && props.item.contact_tags_v2"></v-divider>
                                                <v-list-tile v-if="props.item.contact_tags_v2">
                                                    Contato:
                                                    <v-chip
                                                        v-for="(item,
                                                        index) in props.item.contact_tags_v2.split(',')"
                                                        :key="index"
                                                        outline
                                                        small
                                                        color="blue"
                                                        >{{ item }}
                                                    </v-chip>
                                                </v-list-tile>
                                            </v-list>
                                        </v-card>
                                    </v-menu>
                                </td>
                                <td>
                                    <v-tooltip v-if="props.item.approach" top>
                                        <template v-slot:activator="{ on }">
                                            <a
                                                v-on="on"
                                                style="display: inline-grid"
                                                @click="
                                                    goToApproach(
                                                        props.item.approach
                                                    )
                                                "
                                            >
                                                <p
                                                    class="truncate"
                                                    style="line-height: 19px"
                                                >
                                                    <span
                                                        :class="`tag-approach-type small ${props.item.approach.type}`"
                                                        >{{
                                                            props.item.approach
                                                                .type
                                                        }}</span
                                                    >
                                                    {{
                                                        props.item.approach.name
                                                    }}
                                                </p>
                                            </a>
                                        </template>
                                        <span>{{
                                            props.item.approach.name
                                        }}</span>
                                    </v-tooltip>
                                </td>
                                <td>
                                    <p>
                                        {{
                                            props.item.updated_at
                                                | formatDateTime
                                        }}
                                    </p>
                                </td>
                                <td>
                                    <v-menu bottom left>
                                        <template v-slot:activator="{ on }">
                                            <v-btn icon v-on="on">
                                                <v-icon
                                                    >mdi-dots-vertical</v-icon
                                                >
                                            </v-btn>
                                        </template>
                                        <v-list>
                                            <v-list-tile
                                                @click="
                                                    clickItemAction(
                                                        props.item,
                                                        'updateStatus'
                                                    )
                                                "
                                            >
                                                <v-list-tile-title
                                                    >Desarquivar</v-list-tile-title
                                                >
                                            </v-list-tile>
                                            <v-list-tile
                                                :disabled="
                                                    props.item
                                                        .last_notification_count >
                                                    0
                                                "
                                                @click="
                                                    clickItemAction(
                                                        props.item,
                                                        'delete'
                                                    )
                                                "
                                            >
                                                <v-list-tile-title
                                                    >Excluir</v-list-tile-title
                                                >
                                            </v-list-tile>
                                        </v-list>
                                    </v-menu>
                                </td>
                            </tr>
                            </template>
                            <template v-slot:no-data>
                                <v-container
                                    fluid
                                    fill-height
                                    style="
                                        background-color: rgba(
                                            255,
                                            255,
                                            255,
                                            0.5
                                        );
                                    "
                                >
                                    <v-layout justify-center align-center>
                                        <v-progress-circular
                                            v-if="loading"
                                            indeterminate
                                            color="primary"
                                        ></v-progress-circular>
                                        <span v-else
                                            >Nenhuma estratégia arquivada
                                            encontrada.</span
                                        >
                                    </v-layout>
                                </v-container>
                            </template>
                        </v-data-table>
                    </v-tab-item>
                </v-tabs>
            </v-flex>
        </v-layout>
        <v-dialog
            v-model="dialog"
            persistent
            max-width="500px"
            @keydown.esc="dialog = false"
        >
            <v-card>
                <v-card-title class="headline"
                    >Excluir essa estratégia?</v-card-title
                >
                <v-card-text>{{ strategy_name }}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn outline color="primary" text @click="dialog = false"
                        >Cancelar</v-btn
                    >
                    <v-btn color="primary" text @click="confirmDelete"
                        >Confirmar</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import moment from "moment";
import store from "@/store";
import numeral from "numeral";
import headers from "./headers"
import strategyService from "@/services/strategy";
import strategyPublic from "@/utils/strategy-public";
import SelectCreditors from "@/components/creditor/SelectCreditors";

export default {
    components: {
        SelectCreditors,
    },
    data() {
        return {
            loading: true,
            dialog: false,
            doneFetching: false,
            tableTab: 0,
            selectedCreditor: 1,
            strategy_name: "",
            publicTabs: [],
            selectedApproachTypes: [],
            headers: [],
            approachesTypes: [
                "SMS",
                "PUSH"
            ],
            query: {},
            allStrategies: {
                IMPORTED: {
                    fetched: false,
                    data: [],
                    pagination: {
                        descending: true,
                        page: 1,
                        rowsPerPage: 20,
                        sortBy: "id",
                    },
                    totalItems: 0,
                    rowsPerPageItems: [10, 15, 20],
                },
                UNCHECKED: {
                    fetched: false,
                    data: [],
                    pagination: {
                        descending: true,
                        page: 1,
                        rowsPerPage: 20,
                        sortBy: "id",
                    },
                    totalItems: 0,
                    rowsPerPageItems: [10, 15, 20],
                },
                CHECKED: {
                    fetched: false,
                    data: [],
                    pagination: {
                        descending: true,
                        page: 1,
                        rowsPerPage: 20,
                        sortBy: "id",
                    },
                    totalItems: 0,
                    rowsPerPageItems: [10, 15, 20],
                },
                SANITIZED: {
                    fetched: false,
                    data: [],
                    pagination: {
                        descending: true,
                        page: 1,
                        rowsPerPage: 20,
                        sortBy: "id",
                    },
                    totalItems: 0,
                    rowsPerPageItems: [10, 15, 20],
                },
                LOCATED: {
                    fetched: false,
                    data: [],
                    pagination: {
                        descending: true,
                        page: 1,
                        rowsPerPage: 20,
                        sortBy: "id",
                    },
                    totalItems: 0,
                    rowsPerPageItems: [10, 15, 20],
                },
            },
            last_import_since: new Date().toISOString().substr(0, 10),
        };
    },
    created() {
        this.publicTabs = strategyPublic.strategyPublic;

        this.headers = headers.archived
        this.query = this.$route.query;
        if (Object.keys(this.query).length == 0)
            this.query = store.getters.getManualStrategy;

        if (this.query.types) {
            this.query.types.split(",").forEach((id) => {
                this.selectedApproachTypes.push(id);
            });
        }
        if (this.query.creditors) {
            this.query.creditors.split(",").forEach((id) => {
                this.selectedCreditor = parseInt(id);
            });
        }
        if (typeof this.query !== "undefined") {
            if (this.query.creditor)
                this.selectedCreditor = parseInt(this.query.creditor);

            if (this.query.approachTypes) {
                let _types = this.query.approachTypes.split(",");
                this.selectedApproachTypes = [];
                _types.forEach((p) => {
                    this.approachesTypes.forEach((el) => {
                        if (p == el) this.selectedApproachTypes.push(el);
                    });
                });
            }

            if (this.query.tableTab)
                this.tableTab = parseInt(this.query.tableTab);

            if (this.query.page)
                this.allStrategies[
                    this.publicTabs[this.tableTab].value
                ].pagination.page = parseInt(this.query.page);
            if (this.query.sortBy) {
                this.allStrategies[
                    this.publicTabs[this.tableTab].value
                ].pagination.sortBy = String(this.query.sortBy);
            }
            if (this.query.descending)
                this.allStrategies[
                    this.publicTabs[this.tableTab].value
                ].pagination.descending =
                    this.query.descending == "true" ? true : false;
            if (this.query.rowsPerPage)
                this.allStrategies[
                    this.publicTabs[this.tableTab].value
                ].pagination.rowsPerPage = parseInt(this.query.rowsPerPage);
        }

        this.addfilters();
        this.getDataApi();
        setTimeout(() => (this.doneFetching = true), 1000);
    },
    computed: {
        last_import_sinceFormatted(data) {
            return this.last_import_since
                ? moment
                      .utc(new Date(this.last_import_since).toUTCString())
                      .format("DD/MM/YYYY")
                : "";
        },
    },
    watch: {
        allStrategies: {
            handler() {
                if (this.doneFetching && !this.loading) {
                    this.addfilters();
                    this.getDataApi();
                }
            },
            deep: true,
        },
        selectedCreditor() {
            if (this.doneFetching) this.fetchAll();
        },
        selectedApproachTypes() {
            if (this.doneFetching) this.fetchAll();
        },
        tableTab() {
            if (this.doneFetching) {
                let currentTab = this.publicTabs[this.tableTab].value;
                this.addfilters();
                if (!this.allStrategies[currentTab].fetched) this.getDataApi();
            }
        },
    },
    methods: {
        async removeFromList(id, list) {
            return list.filter(function (e) {
                return e.id !== id;
            });
        },
        fetchAll() {
            this.changeFilter();
            this.addfilters();
            this.getDataApi();
        },
        changeFilter() {
            Object.keys(this.allStrategies).forEach((tab) => {
                this.allStrategies[tab] = {
                    fetched: false,
                    data: [],
                    pagination: {
                        descending: true,
                        page: 1,
                        rowsPerPage: 20,
                        sortBy: "id",
                    },
                    totalItems: 0,
                    rowsPerPageItems: [10, 15, 20],
                };
            });
        },
        getDataApi() {
            this.loading = true;
            let currentTab = this.publicTabs[this.tableTab].value,
                filter = {
                    order: "",
                    limit: "",
                    page: "",
                },
                pagination = this.allStrategies[
                    this.publicTabs[this.tableTab].value
                ].pagination;

            filter.page = pagination.page;
            filter.limit =
                pagination.rowsPerPage == -1 ? 9999 : pagination.rowsPerPage;
            if (pagination.sortBy)
                filter.order =
                    (pagination.descending ? "-" : "") + pagination.sortBy;

            setTimeout(() => {
                strategyService
                    .list(
                        this.selectedCreditor,
                        false,
                        currentTab,
                        filter,
                        false,
                        this.selectedApproachTypes
                    )
                    .then((res) => {
                        this.allStrategies[currentTab].data = res.objects;
                        this.allStrategies[currentTab].fetched = true;
                        this.allStrategies[currentTab].totalItems =
                            res.num_results;
                        this.createStrategySegment(currentTab);
                    })
                    .catch((error) => {
                        console.error(error);
                        this.$store.commit(
                            "showSnackbar",
                            "Houve um erro ao buscar os dados"
                        );
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }, 500);
        },
        addfilters() {
            let pagination = this.allStrategies[
                this.publicTabs[this.tableTab].value
            ].pagination;
            this.query = {};

            this.query.tableTab = this.tableTab;

            if (this.selectedCreditor > 0)
                this.query.creditor = this.selectedCreditor;

            if (this.selectedApproachTypes.length) {
                this.query.approachTypes = this.selectedApproachTypes
                    .map((sp) => sp)
                    .join(",");
            }
            
            if (pagination.page) this.query.page = pagination.page;
            if (pagination.sortBy) this.query.sortBy = pagination.sortBy;
            else this.query.sortBy = 0;
            if (pagination.descending != null)
                this.query.descending = pagination.descending;
            if (pagination.rowsPerPage)
                this.query.rowsPerPage = pagination.rowsPerPage;

            this.$store.commit("setManualStrategy", this.query);
            if (this.$route.path == "/strategies/archived") {
                this.$router.push({
                    name: "Arquivados",
                    query: this.query,
                });
            }
        },
        createStrategySegment(tab) {
            let vm = this;
            let days, debts;
            vm.allStrategies[tab].data.forEach((str) => {
                str.value_type = str.value_type ? str.value_type : "PRINCIPAL";
                days = "";
                debts = "";
                if (str.min_days_of_delay)
                    days = " > " + numeral(str.min_days_of_delay).format("0,0");
                if (str.max_days_of_delay)
                    days +=
                        " < " + numeral(str.max_days_of_delay).format("0,0");
                days += " dias";
                if (str.min_debit)
                    debts =
                        " > " +
                        "R$ " +
                        numeral(str.min_debit).format("0,0[.]00");
                if (str.max_debit)
                    debts +=
                        " < " +
                        "R$ " +
                        numeral(str.max_debit).format("0,0[.]00");
                let _type = str.value_type.substr(0, 1);
                if (_type == "B") _type = "C";
                // Ajuste para o valor contábil
                else if (_type == "N") _type = "P";
                debts = _type + debts;

                if (!str.min_days_of_delay && !str.max_days_of_delay)
                    days = "Qualquer atraso";
                if (!str.min_debit && !str.max_debit) debts = "qualquer valor";
                str.segmentString = days + " e " + debts;
                if (
                    !str.min_days_of_delay &&
                    !str.max_days_of_delay &&
                    !str.min_debit &&
                    !str.max_debit
                )
                    str.segmentString = "Qualquer atraso e valor";
            });
        },
        hasTag(item) {
            let tags_v2 = item.tags_v2 != null ? item.tags_v2.length : 0;
            let contact_tags_v2 =
                item.contact_tags_v2 != null ? item.contact_tags_v2.length : 0;
            if (!tags_v2 && !contact_tags_v2) return false;
            return true;
        },
        checkNotificationToday(date) {
            if (!date) return false;
            let value = date.includes("Z")
                ? new Date(date)
                : new Date(date + "Z");
            let _diff = moment().isSame(moment.utc(value).local(), "day");
            return _diff;
        },
        async clickItemAction(item, action) {
            if (action == "delete") {
                this.deleteStrategy(item.id, item.name);
            } else if (action == "updateStatus") {
                await this.updateStrategyStatus(item);
            }
        },
        async deleteStrategy(strategy_id, strategy_name) {
            this.dialog = true;
            this.strategy_name = strategy_name;
            this.strategy_id = strategy_id;
        },
        async confirmDelete() {
            let vm = this;
            let currentTab = vm.publicTabs[vm.tableTab].value;
            vm.dialog = false;
            await strategyService
                .delete(vm.strategy_id)
                .then(async (res) => {
                    vm.allStrategies[currentTab].data = await vm.removeFromList(
                        vm.strategy_id,
                        vm.allStrategies[currentTab].data
                    );
                    vm.$store.commit("showSnackbar", {
                        message: `Estratégia excluida com sucesso!`,
                        important: true,
                    });
                })
                .catch((err) => {
                    console.error(err);
                    vm.$store.commit(
                        "showSnackbar",
                        "Houve um erro ao excluir a estratégia"
                    );
                });
        },
        async updateStrategyStatus(strategy) {
            strategy.active = !strategy.active;
            let vm = this;
            let currentTab = vm.publicTabs[vm.tableTab].value;
            let message = "";
            strategy = {'id':strategy.id,'active':strategy.active,'name':strategy.name,'selected':strategy.selected}
            await strategyService
                .save(strategy)
                .then(async (res) => {
                    message = `Estratégia ${strategy.name} desarquivada!`;
                    this.$store.commit("showSnackbar", {
                        message,
                        important: true,
                    });
                    if (res == undefined) {
                        this.$store.commit(
                            "showSnackbar",
                            "Houve um erro ao salvar"
                        );
                        return console.error("houve um erro");
                    }
                    if (strategy.selected) vm.setSelected(strategy);
                    vm.allStrategies[currentTab].data = await vm.removeFromList(
                        strategy.id,
                        vm.allStrategies[currentTab].data
                    );
                })
                .catch((error) => {
                    this.$store.commit(
                        "showSnackbar",
                        "Houve um erro ao salvar"
                    );
                    console.error("Houve um erro", error);
                });
        },
        goToApproach(approach) {
            this.$router.push({
                name: "Abordagem",
                params: {
                    edit: true,
                    approach_id: approach.id,
                },
            });
        },
    },
};
</script>

<style>
</style>